import { Box, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import WhiteCard from "src/shared/components/WhiteCard";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { theme } from "src/assets/theme";
import { useLatestPrescription } from "src/context/LatestPrescriptionProvider";

const PrescriptionNotice = () => {
  const { t } = useTranslation();
  const component = "patient-dashboard.prescription-notice";
  const medication = useLatestPrescription((prescription) => {
    if (prescription.product.slug === "ec") return null;

    const name = t(`products.${prescription.product.slug}.name`);

    return name.toLowerCase();
  });

  if (medication == null) return null;

  return (
    <WhiteCard
      direction={"row"}
      gap={1}
      alignContent={"center"}
      justifyContent={"center"}
    >
      <Box sx={{ color: theme.palette.secondary.main }}>
        <PendingActionsIcon fontSize="large" />
      </Box>
      <Typography variant="h6" fontWeight={700}>
        {t(
          `${component}.text`,
          `Hang tight! Your {{medication}} prescription request is being reviewed. We’ll notify you as soon as it’s approved.`,
          {
            medication,
          },
        )}
      </Typography>
    </WhiteCard>
  );
};

export default PrescriptionNotice;
